module.exports = __webpack_public_path__ + "static/media/banner-area-4.c4eb18da.png";